<div class="notification-message-container padding-content-dialog">
  <div class="section-notification icon-notification-close font-omicron-bold">
    <span *ngIf="!notificationMessage.hideCloseButton" class="cursor-pointer" (click)="closeModal()">
      <svg xmlns="http://www.w3.org/2000/svg" width="15.6" height="15.598" viewBox="0 0 15.6 15.598">
        <path
          d="M23.137,8.2a1.13,1.13,0,0,0-1.6,0l-5.866,5.866L9.8,8.2A1.131,1.131,0,0,0,8.2,9.8l5.866,5.866L8.2,21.537a1.131,1.131,0,0,0,1.6,1.6l5.863-5.863,5.866,5.866a1.131,1.131,0,1,0,1.6-1.6l-5.87-5.87L23.137,9.8A1.135,1.135,0,0,0,23.137,8.2Z"
          transform="translate(-7.873 -7.872)" />
      </svg>
    </span>
  </div>
  <div class="
      section-notification-img-header section-notification-img
      font-omicron-bold
    ">
    <mat-icon *ngIf="notificationMessage.typeIcon === typeIcons.success"
      class="icon-success animate__animated animate__flip">
      <svg xmlns="http://www.w3.org/2000/svg" height="70" viewBox="0 0 44 44" width="70">
        <path d="M0 0h24v24H0V0z" fill="none" />
        <path
          d="M19.77 5.03l1.4 1.4L8.43 19.17l-5.6-5.6 1.4-1.4 4.2 4.2L19.77 5.03m0-2.83L8.43 13.54l-4.2-4.2L0 13.57 8.43 22 24 6.43 19.77 2.2z" />
      </svg>
    </mat-icon>
    <mat-icon *ngIf="notificationMessage.typeIcon === typeIcons.question"
      class="icon-question animate__animated animate__flip">
      <svg xmlns="http://www.w3.org/2000/svg" height="70" viewBox="0 0 44 44" width="70">
        <path d="M0 0h24v24H0z" fill="none" />
        <path
          d="M11 18h2v-2h-2v2zm1-16C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8zm0-14c-2.21 0-4 1.79-4 4h2c0-1.1.9-2 2-2s2 .9 2 2c0 2-3 1.75-3 5h2c0-2.25 3-2.5 3-5 0-2.21-1.79-4-4-4z" />
      </svg>
    </mat-icon>
    <mat-icon *ngIf="notificationMessage.typeIcon === typeIcons.error"
      class="icon-error animate__animated animate__flip">
      <svg xmlns="http://www.w3.org/2000/svg" height="70" viewBox="0 0 44 44" width="70">
        <path d="M0 0h24v24H0z" fill="none" />
        <path
          d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" />
      </svg>
    </mat-icon>
    <mat-icon *ngIf="notificationMessage.typeIcon === typeIcons.info" class="icon-info animate__animated animate__flip">
      <svg xmlns="http://www.w3.org/2000/svg" height="70" viewBox="0 0 44 44" width="70">
        <path d="M0 0h24v24H0z" fill="none" />
        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-6h2v6zm0-8h-2V7h2v2z" />
      </svg>
    </mat-icon>
    <mat-icon *ngIf="notificationMessage.typeIcon === typeIcons.scanned"
      class="icon-info animate__animated animate__flip">
      <svg xmlns="http://www.w3.org/2000/svg" width="65" height="70" viewBox="0 0 34 40">
        <path
          d="M7,20H7a45.452,45.452,0,0,1-3.5-4.53C1.9,13.1,0,9.712,0,7A7,7,0,0,1,11.952,2.049,6.955,6.955,0,0,1,14,7c0,2.712-1.9,6.1-3.5,8.468A45.452,45.452,0,0,1,7,20ZM7,4.5A2.5,2.5,0,1,0,9.5,7,2.5,2.5,0,0,0,7,4.5Z" />
      </svg>
    </mat-icon>
    <mat-icon *ngIf="
        notificationMessage.typeIcon === typeIcons.assign ||
        notificationMessage.typeIcon === typeIcons.delivered
      " class="animate__animated animate__flip">
      <svg xmlns="http://www.w3.org/2000/svg" width="14" height="20" viewBox="0 0 14 20">
        <path
          d="M7,20H7a45.452,45.452,0,0,1-3.5-4.53C1.9,13.1,0,9.712,0,7A7,7,0,0,1,11.952,2.049,6.955,6.955,0,0,1,14,7c0,2.712-1.9,6.1-3.5,8.468A45.452,45.452,0,0,1,7,20ZM7,4.5A2.5,2.5,0,1,0,9.5,7,2.5,2.5,0,0,0,7,4.5Z" />
      </svg>
    </mat-icon>
  </div>
  <div class="primary-content">
    <mat-dialog-content class="content-dialogs-scroll">
      <div class="section-notification text-notification">
        <span *ngIf="!containsInnerHtml" class="title-size-4" [innerHTML]="this.message"> </span>
        <span *ngIf="containsInnerHtml" class="style-containers" [innerHTML]="this.message"> </span>
      </div>
    </mat-dialog-content>
    <mat-dialog-actions>
      <div class="
          section-footer-notification
          footer-notification
          font-omicron-bold
          justify-content-center
        ">
        <div class="section-footer-detail">
          <button name="btn-cancel" type="button" mat-stroked-button color="primary" class="
              with-buttons-notification
              white-button
              font-size-button
              d-flex
              flex-nowrap
            " *ngIf="notificationMessage.isButtonCancel" matDialogClose (click)="closeModal()">
            {{ notificationMessage.textCancel?notificationMessage.textCancel :'Cancelar'}}
          </button>
        </div>
        <div class="section-footer-detail">
          <button name="btn-accept" mat-raised-button class="with-buttons-notification blue-button font-size-button"
            (click)="okModal()" color="primary">
            {{ notificationMessage.textAcept?notificationMessage.textAcept : 'Aceptar'}}
          </button>
        </div>
      </div>
    </mat-dialog-actions>
  </div>
</div>